import { render, staticRenderFns } from "./CRTerms.vue?vue&type=template&id=7e995cc6"
import script from "./CRTerms.vue?vue&type=script&lang=js"
export * from "./CRTerms.vue?vue&type=script&lang=js"
import style0 from "./CRTerms.vue?vue&type=style&index=0&id=7e995cc6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports